import { IAppState } from '../../../AppModulesWrapper';

export function selectIsAutoProlongChecked(state: IAppState): boolean {
  const {
    checkoutInfo: { autoProlongInfo },
  } = state.servicePickerWidget;

  return autoProlongInfo.isChecked;
}
